export const setInitialWizardTaken = () => {
  localStorage.setItem("isInitialOnboardingCompleted", "true");
};
export const getUserNameWithConditionalCheck = (
  displayName: string,
  firstName: string,
  lastName: string,
  email?: string
) => {
  if (email)
    return displayName
      ? `${displayName} ${email ? "(" + email + ")" : ""}`
      : `${firstName || ""} ${lastName || ""} ${email ? "(" + email + ")" : ""}`;
  return displayName ? displayName : `${firstName || ""} ${lastName || ""}`;
};
